module.exports = __webpack_public_path__ + "static/media/floor_tom_7.eb08ffbc.png";